// extracted by mini-css-extract-plugin
export default {"notFound":"NotFoundPage_notFound__gTfDQ"};